import React from 'react';
import Recipes from './recipes'
import JPlus from './jPlus'
import styles from './pearlDoser.module.css'
import LoadingSpinner from '../loadingSpinner'
import {wsTrans} from '../../utils/utils'
import { readJPro,readXBoards,saveJPros,withTimeout,setSensorNames,
} from "../C18AiUtils";
import {cl,globs,getRandomString} from '../../../components/utils/utils';
import {getSensorsZone} from '../C18utils'

class DoserRecipes extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.cps=[
      1,2,3,4,5,6,7,8,
      1,2,3,4,5,6,7,8,]
    this.state={
      loaded:false,
      editRecipe:{
        name:"",
        concs:new Array(64).fill(0),
      },
      jPlus:[
        {
          name:"jPlus 1",
          mbAddr:0,
          nutes:["None","None","None","None","None","None","None","None",
          "None","None","None","None","None","None","None","None",],
          cps:[1,2,3,4,5,6,7,8,1,2,3,4,5,6,7,8,],
        }
      ],
    }
    this.subscribe_savePageEvent=globs.events
      .subscribe("savePageEvent",this.savePage)
  }

  componentDidMount=()=>{
    this.loadInfo()
  }

  componentWillUnmount=()=>{
    if (this.subscribe_savePageEvent && this.subscribe_savePageEvent.remove) {
      this.subscribe_savePageEvent.remove();
    }
  }

  pageMouseDown=(e)=>{// should block if *not* editing
    let st=this.state
    if((st.jpEdit=="none")&&(st.recEdit=="none")){return}
    if(e.target.id.substring(0,4)!="edit"){this.setEditMode()}
  }

  loadInfo=async()=>{
    let pa=this.props.parms
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
//     cl(zone)
    let body={
      zoneId:pa.zone,
    }
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: body})
    let stateVals={
      loaded:true,
//       jPro:readJPro(zone.siteZoneIndex,0),
      xBoards:readXBoards(zone.siteZoneIndex),
      zInd:zone.siteZoneIndex
    }
//     cl(stateVals.jPro)
    for(let val of res.data){
      stateVals[val.type]=val.value
    }
    (stateVals.schedule||[]).forEach(s=>{
//       cl(s)
      if(!s.durMins){s.durMins=0}
    })
    stateVals.recipes=(stateVals.recipes||[]).filter(r=>{
      return r.recipeId&&(r.recipeId!="none")
    })
    stateVals.jPro=readJPro(zone.siteZoneIndex,
      stateVals.xBoards,stateVals.jPlus?.length??0)
//     cl(stateVals)
//     stateVals.schedule.forEach(s=>s.durMins=0)
    this.setState((stateVals))
  }

  doSave=async(field)=>{
    cl(`save ${field}`)
    let pa=this.props.parms
    let st=this.state
    let body={
      zoneId:pa.zone,
      type:field,
      value:st[field]
    }
//     cl(body)
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/pearlDoser", method: "update",
      sessionId: globs.userData.session.sessionId, body: body})
  }

  saveEditRecipe=()=>{
    let st=this.state
    let recipes=st.recipes.slice(0)
    let selRecipe=st.recipes.filter(r=>r.recipeId==st.selRecipe)[0]
//     cl(st.editRecipe)
    if(st.editRecipe.recipeId!="none"){// not deleted
      if(!selRecipe){
        recipes.push(st.editRecipe)// if new
      }else{// updated
        selRecipe.name=st.editRecipe.name
        selRecipe.concs=st.editRecipe.concs.slice(0)
      }
    }
//     cl(selRecipe.name)
//     cl(recipes)
    this.setState({recipes:recipes,changed:false})
  }

  saveSensorNames=async()=>{
    let {zone}=this.props.parms
    let zoneInfo=globs.zonesInfo.info.find(z=>z.zoneId==zone)
    let sensors=getSensorsZone(zone).sensorNames
    setSensorNames(sensors)
    await wsTrans("usa", {cmd: "cRest", uri: "/s/sensors", method: "update",
      sessionId: globs.userData.session.sessionId,
      body: {zoneId: zone, siteId:zoneInfo.siteId, sensorNames:sensors}})

  }

  doSavePage=async()=>{
    let st=this.state
    this.setSavePage(false)
//     cl("saveRecipes")
//     cl(st.editRecipes)
//     cl(st.recipes[3].concs)
//     cl(st.editRecipe)
    if(st.editRecipes){
//       cl("saving recipes")
      this.saveEditRecipe()
      await this.doSave("recipes")
      this.setState({editRecipes:false})
    }
//     if(st.editSchedule){await this.doSave("schedule")}
//     if(st.editTimeEnables){await this.doSave("timeEnables")}
    if(st.editJPlus){
      await this.doSave("jPlus")
      await this.saveSensorNames()
//       cl(st)
      let jPlusUsed=st.jPlus.filter(jp=>!jp.notUsed)
      let xBoards=await saveJPros(st.zInd,jPlusUsed,st.xBoards)

      this.setState({xBoards:xBoards.slice(0)})
    }
//     globs.events.publish("saveOK",true)
//     cl("saveRecipeDone")
//     globs.events.publish("savePageEnable",false)
  }

  savePage=async()=>{
    let res=await withTimeout(this.doSavePage(),5000)
//     cl(res)
    if(res!="to"){globs.events.publish("saveOK",true)}
  }

  deleteRecipe=()=>{
    let st=this.state
    cl("delete recipe")
    let recipes=st.recipes.filter(r=>r.recipeId!=st.selRecipe)
    let editRecipe={
      recipeId:"none",
      name:"",
      concs:new Array(64).fill(0),
    }
    let schedule=st.schedule.slice(0)
    schedule.forEach(s=>{
      if(s.recipeId==st.selRecipe){
        s.recipeId="none"
        s.dayMins=0
        s.durMins=0
      }
    })
    this.setState({
      selRecipe:"none",
      recipes:recipes,
      editRecipes:true,
      editRecipe:editRecipe})
  }

  setSavePage=(set)=>{
    globs.events.publish("savePageEnable",set)
    this.setState({changed:set})
    this.props.onChange({type:"change",value:(set)?this.savePage:null})
  }



  newRecipe=()=>{
    let st=this.state
//     globs.events.publish("savePageEnable",true)
    this.setSavePage(true)
    cl("newRecipe")
    cl(st)
    let blankRecipe=st.recipes.find(r=>Math.max(...r.concs)==0)
    if(blankRecipe){
      this.setState({
        selRecipe:blankRecipe.recipeId,
        editRecipe:Object.assign({},blankRecipe),

      })
      return
    }
    let editRecipe={
      recipeId:getRandomString(16),
      name:`New Recipe ${(st.recipes||[]).length+1}`,
      concs:new Array(64).fill(0),
    }
    let pushRecipe=Object.assign({},editRecipe)
    pushRecipe.concs=editRecipe.concs.slice(0)
    let recipes=(st.recipes||[]).slice(0)
    recipes.push(pushRecipe)
    this.setState({
      recipes:recipes,
      editRecipe:editRecipe,
      editRecipes:true,
      selRecipe:pushRecipe.recipeId})
  }

  setEditMode=(cont,mode)=>{
//     cl(cont,mode)
    let stateVals={};
    ["recEdit","jpEdit"].forEach(c=>{
      stateVals[c]=(c==cont)?mode:"none"
    })
//     cl(stateVals)
    this.setState(stateVals)
  }

  onRecipesChange=async(values)=>{
    let st=this.state
//     cl(st)
//     cl(values)
    if((values.type!="edit")&&(values.type!="select")){
      cl("recipe change")
      this.setSavePage(true)
//       globs.events.publish("savePageEnable",true)
//       this.props.onChange({type:"change",value:this.savePage})
    }
//     if(!["select","edit"].includes(values.type)){globs.events.publish("savePageEnable",true)}
//     cl(values)
//     cl(st.recipes)
    var editRecipe//, editRecipe

    switch(values.type){
      case "name":
        editRecipe=Object.assign(st.editRecipe)
        editRecipe.name=values.value
        this.setState({editRecipe:editRecipe,editRecipes:true/*,jpEdit:"none"*/})
        break
      case "select":
        if(values.value=="new"){return this.newRecipe()}
        if(st.changed){
          let res=await this.props.parms.getPopup({text:"Do you want to save your \
changes to this recipe?",buttons:["No","Yes"]})
          if(res=="Yes"){
//             cl("save recipe")
//             cl(st.editRecipe)
            this.saveEditRecipe()
            this.setState({editRecipes:true})
          }
        }

//         let oldRecipe=st.recipes.find(r=>r.recipeId==st.selRecipe)
//         if(oldRecipe){
//           cl(oldRecipe)
//           let max=Math.max(...oldRecipe.concs)
//           if(!max){oldRecipe.name="Blank Recipe"}
//           this.setState({recipes:st.recipes.slice(0)})
//           cl(max)
//         }
        let selRecipe=st.recipes.filter(r=>r.recipeId==values.value)[0]
        if(selRecipe){
          editRecipe={
            name:selRecipe.name,
            concs:selRecipe.concs.slice(0)
          }
        }else{
          editRecipe={
            name:"No Recipe Selected",
            concs:new Array(64).fill(0),
          }
        }
        this.setState({
          selRecipe:values.value,
          editRecipe:editRecipe,
//           editRecipes:false,
        })
        break
      case "new":
        this.newRecipe()
        break
      case "delete":
        this.deleteRecipe()
        break
      case "edit":
//         this.setState({recEdit:values.value})
//         this.setState()
        if(st.selRecipe!="none"){this.setEditMode("recEdit",values.value)}
        break
    }
  }

  onJPlusChange=(values)=>{
//     cl(values)
    let st=this.state
//     values.unit=0// tempFix
    let jPlus=st.jPlus.slice(0)
    if(values.type!="edit"){
//       globs.events.publish("savePageEnable",true)
      this.setSavePage(true)
    }
    var setVal
    switch(values.type){
      case "jpName":
        jPlus[values.jpIndex].name=values.value
        break
      case "jpModbus":
        jPlus[values.jpIndex].mbAddr=values.value
        cl(jPlus)
        break
      case "nuteName":
        jPlus[values.jpIndex].nutes[values.index]=values.value
//         cl(values.index+16*values.jpIndex)
//         cl(jPlus)
        break
      case "nuteConc":
        let editRecipe=Object.assign(st.editRecipe)
        editRecipe.concs[values.index+16*values.jpIndex]=values.value
        this.setState({editRecipe:editRecipe,editRecipes:true})
        break
      case "edit":
//         cl(st.selRecipe,values.value)
        if((st.selRecipe!="none")||(values.value!="nuteConc")){
//           cl("set edit")
          this.setEditMode("jpEdit",values.value)

        }
        break
    }
    this.setState({jPlus:jPlus,editJPlus:true})
  }

  showJPlus=()=>{
    let st=this.state
    let pr=this.props
    return st.jPlus.filter(jp=>!jp.notUsed)
      .map((jp,ind)=>{
//         cl(jp)
      let pumpers=[]
      for(let i=0;i<16;i++){
        pumpers.push({
          nutrientName:jp.nutes[i],
          concentration:st.editRecipe.concs[16*ind+i]||0,
        })
      }
//       cl(pumpers)
//       cl(st.enAdv)
      return(
        <React.Fragment key={ind}>
          <JPlus
            jpIndex={ind}
            config={{
              name:jp.name,
              modbusAddress:jp.mbAddr,
              pumpers:pumpers,
              cps:st.jPro[ind]?.cps??[],//this.cps,
            }}
            units={pr.units}
            enAdv={st.enAdv}
            editMode={st.jpEdit}
            onChange={this.onJPlusChange}
          />
          {(ind<st.jPlus.length-1)&&
            <hr/>
          }
        </React.Fragment>
      )
    })
  }

  addJPlus=()=>{
//     cl("addJPlus")
    let st=this.state
    let jPlus=st.jPlus.slice(0)
    let ind=jPlus.filter(jp=>!jp.notUsed).length
    if(jPlus[ind]){
      jPlus[ind].notUsed=false
    }else{
      jPlus.push(
        {
          name:`jPlus ${ind+1}`,
          mbAddr:0,
          nutes:["None","None","None","None","None","None","None","None",
          "None","None","None","None","None","None","None","None",],
          cps:[1,2,3,4,5,6,7,8,1,2,3,4,5,6,7,8,],
        }
      )
    }
//     globs.events.publish("savePageEnable",true)
    this.setSavePage(true)
    this.setState({jPlus,editJPlus:true})
  }

  delJPlus=()=>{
    let st=this.state
//     cl("delJPlus")
    let jPlus=st.jPlus.slice(0)
    for(let i=jPlus.length-1;i>=0;i--){
      let jp=jPlus[i]
      if(!jp.notUsed){jp.notUsed=true;break}
    }
//     jPlus[jPlus.length-1].notUsed=true
//     globs.events.publish("savePageEnable",true)
    this.setSavePage(true)
    this.setState({jPlus,editJPlus:true})
  }

  enAdv=(ev)=>{
//     cl(ev.currentTarget.checked)
    this.setState({enAdv:ev.currentTarget.checked})
  }

  render(){
    let st=this.state
    let pr=this.props
    let ind=st.jPlus.filter(jp=>!jp.notUsed).length
//     cl(st)
    if(st.loaded){
      return(
        <div className={styles.pearlDoser}
        style={{padding:20}}
          onMouseDown={this.pageMouseDown}
        >
        <h3>Edit Recipes</h3>
        <div style={{width:"fit-content"}}>
          <input id="enAdv" type="checkbox" style={{minWidth:0}}
          onClick={this.enAdv}
          />
          <label htmlFor="enAdv" style={{display:"inline-block"}}>
            &nbsp;Enable Advanced
          </label><br/>&nbsp;
        </div>
        <div
          className={styles.borderDiv}
        >
          <Recipes
            names={st.recipes||[]}
            selectedId={st.selRecipe}
            editMode={st.recEdit}
            editName={st.editRecipe.name}
            notSaved={false}
            units={pr.units}
            onChange={this.onRecipesChange}
          />
          {st.editRecipes&&
            <span style={{fontSize:18,fontWeight:700,color:"#c0c000"}}>
            Not Saved<br/>&nbsp;</span>
          }
          {this.showJPlus()}
          {st.enAdv&&
            <React.Fragment>
            {(ind<4)&&
              <>
                <span
                  onClick={this.addJPlus}
                  title="Add a JPro"
                  className={styles.charButAz}
                >+</span>&nbsp;
              </>
            }
            {(ind>1)&&
              <span
                onClick={this.delJPlus}
                className={styles.charButR}
              >x</span>
            }
            </React.Fragment>
          }
        </div>
      </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
  }
}

export default DoserRecipes;
